import { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

// import required modulesanother-publisher
import { Navigation, Autoplay } from "swiper/modules";

import "./App.css";
import GajmarketLogo from "./assets/images/logo.png";
import GajmarketLogoMobile from "./assets/images/mobile/logo-m.png";
import ArrowDownSvg from "./assets/svg/arrowDownSvg";
import LogoFooterMobile from "./assets/images/mobile/Logo - Gajmarket-mobile.png";
import MainBackground from "./assets/images/main-bc.png";
import KomakDarsi from "./assets/images/komak-darsi-image.png";
import logogajmarkettext from "./assets/images/logogajmarkettext.png";
import Book1 from "./assets/images/book-1.png";
import Book2 from "./assets/images/book-2.png";
import Book3 from "./assets/images/book-3.png";
import Book4 from "./assets/images/book-4.png";
import Book5 from "./assets/images/book-5.png";
import Book6 from "./assets/images/book-6.png";
import Book7 from "./assets/images/book-7.png";
import Book8 from "./assets/images/book-8.png";
import More from "./assets/images/more.png";
import Publisher1 from "./assets/images/publisher1.png";
import Publisher2 from "./assets/images/publisher2.png";
import Publisher3 from "./assets/images/publisher3.png";
import Publisher4 from "./assets/images/publisher4.png";
import Publisher5 from "./assets/images/publisher5.png";
import Publisher6 from "./assets/images/publisher6.png";
import Publisher7 from "./assets/images/publisher7.png";
import Publisher8 from "./assets/images/publisher8.png";
import Publisher9 from "./assets/images/publisher9.png";

import BackgroundMobile from "./assets/images/mobile/bc-m.png";
import HelpTextMobile from "./assets/images/mobile/help-text-m.png";
import LogoTextMobile from "./assets/images/mobile/text-logo-m.png";
import Bookm1 from "./assets/images/mobile/bookm1.png";
import Bookm2 from "./assets/images/mobile/bookm2.png";
import Bookm3 from "./assets/images/mobile/bookm3.png";
import Bookm4 from "./assets/images/mobile/bookm4.png";
import Bookm5 from "./assets/images/mobile/bookm5.png";
import Bookm6 from "./assets/images/mobile/bookm6.png";
import Bookm7 from "./assets/images/mobile/bookm7.png";
import Bookm8 from "./assets/images/mobile/bookm8.png";

import Instagram from "./assets/images/instagram.png";
import telegram from "./assets/images/telegram.png";
import InstagramM from "./assets/images/mobile/instagramm.png";
import telegramM from "./assets/images/mobile/telegramm.png";
import LogoFooter from "./assets/images/logo-footer.png";

function App() {
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  const leadingZero = (num) => {
    return num < 10 && num > 0 ? "0" + num : num;
  };

  const eventDate = new Date(2023, 9, 23, 0, 0, 0, 0);

  useEffect(() => {
    getTimeDifference(eventDate);
    const interval = setInterval(() => getTimeDifference(eventDate), 1000);
    return () => clearInterval(interval);
  }, [eventDate]);

  const getTimeDifference = (eventDate) => {
    const time = Date.parse(eventDate) - Date.parse(new Date());
    const days = Math.floor(time / (1000 * 60 * 60 * 24));
    const hours = Math.floor((time / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((time / 1000 / 60) % 60);
    const seconds = Math.floor((time / 1000) % 60);
    setDays(days);
    setHours(hours);
    setMinutes(minutes);
    setSeconds(seconds);
  };

  return (
    <>
      <div className="container desktop">
        <a href="#mainSection">
          <div className="mainImageContainer">
            <img className="main-img" src={MainBackground} />
            <div className="centered">
              <img style={{ marginTop: "25px" }} src={GajmarketLogo} />
              <div class="flex-bc">
                <div>
                  <img className="komak-darsi-img" src={KomakDarsi} />
                </div>
                {/* <div>
                  <p className="info-text">
                    تا
                    <span style={{ fontSize: "64px", margin: "0 10px" }}>
                      ۳۰
                    </span>
                    درصد تخفیف
                  </p>
                  <p className="info-text-m">۱۵  تا ۳۰ مهر</p>
                  <div className="time-left">
                    <p className="time-text-title">زمان باقی مانده</p>
                    <p className="time-text">
                      {leadingZero(days)} : {leadingZero(hours)} :
                      {leadingZero(minutes)} : {leadingZero(seconds)}
                    </p>
                  </div>
                </div> */}
              </div>
              <div className="header">
                <span style={{ position: "relative", top: "14px" }}>
                  <img src={logogajmarkettext} />
                </span>
                <span className="header-text">
                  ؛ فروشگاه تخصصی کتاب و لوازم تحریر
                </span>
              </div>
            </div>
            <div className="arowContainer">
              <div className="arrowDown">
                <ArrowDownSvg />
              </div>
            </div>
          </div>
        </a>

        <Swiper
          slidesPerView={5}
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          spaceBetween={20}
          navigation={true}
          modules={[Navigation, Autoplay]}
          className="mySwiper"
        >
          <SwiperSlide>
            <a
              target=""
              className="logoLink"
              id="Publisher3"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D8%AE%DB%8C%D9%84%DB%8C-%D8%B3%D8%A8%D8%B2"
            >
              <img src={Publisher3} />
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a
              target=""
              className="logoLink"
              id="Publisher2"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D9%85%D8%A8%D8%AA%DA%A9%D8%B1%D8%A7%D9%86-2"
            >
              <img src={Publisher2} />
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a
              target=""
              className="logoLink"
              id="Publisher1"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D8%A8%DB%8C%D9%86-%D8%A7%D9%84%D9%85%D9%84%D9%84%DB%8C-%DA%AF%D8%A7%D8%AC"
            >
              <img src={Publisher1} />
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a
              target=""
              className="logoLink"
              id="Publisher4"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D8%A7%D9%84%DA%AF%D9%88"
            >
              <img src={Publisher4} />
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a
              target=""
              className="logoLink"
              id="Publisher5"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D9%85%D9%87%D8%B1-%D9%88-%D9%85%D8%A7%D9%87"
            >
              <img src={Publisher5} />
            </a>
          </SwiperSlide>

          <SwiperSlide>
            <a
              target=""
              className="logoLink"
              id="Publisher7"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D9%85%D8%B4%D8%A7%D9%88%D8%B1%D8%A7%D9%86-%D8%A2%D9%85%D9%88%D8%B2%D8%B4-2"
            >
              <img src={Publisher7} />
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a
              target=""
              className="logoLink"
              id="Publisher8"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D9%86%D8%A7%D8%B1%D9%86%D8%AC%DB%8C"
            >
              <img src={Publisher8} />
            </a>
          </SwiperSlide>
          <SwiperSlide>
            <a
              target=""
              className="logoLink"
              id="Publisher9"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%DA%A9%D8%A7%D9%86%D9%88%D9%86-%D9%81%D8%B1%D9%87%D9%86%DA%AF%DB%8C-%D8%A2%D9%85%D9%88%D8%B2%D8%B4-%D9%82%D9%84%D9%85-%DA%86%DB%8C"
            >
              <img src={Publisher9} />
            </a>
          </SwiperSlide>
        </Swiper>
        <div className="main-box">
          <div id="mainSection" className="categoryContainer">
            <a
              target=""
              className="logoLink"
              id="Book1"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D8%A8%DB%8C%D9%86-%D8%A7%D9%84%D9%85%D9%84%D9%84%DB%8C-%DA%AF%D8%A7%D8%AC"
            >
              <div className="categoryBox">
                <img
                  className="categoryImageBorderRadius"
                  alt="PublicBooks"
                  src={Book1}
                />
                <div className="categoryInfo">
                  <a className="categoryBotton" id="btnBook1">
                    <span>انتشارات بین المللی گاج</span>
                  </a>
                </div>
              </div>
            </a>

            <a
              target=""
              className="logoLink"
              id="Book2"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D8%AE%DB%8C%D9%84%DB%8C-%D8%B3%D8%A8%D8%B2"
            >
              <div className="categoryBox">
                <a target="" className="logoLink">
                  <img
                    className="categoryImageBorderRadius"
                    src={Book2}
                    alt="ChildrenBooks"
                  />
                </a>
                <div className="categoryInfo">
                  <a className="categoryBotton2" id="btnBook2">
                    <span>خیــلـــــی سبـــــز</span>
                  </a>
                </div>
              </div>
            </a>
            <a
              target=""
              className="logoLink"
              id="Book3"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D9%85%D9%87%D8%B1-%D9%88-%D9%85%D8%A7%D9%87"
            >
              <div className="categoryBox">
                <a target="" className="logoLink">
                  <img src={Book3} alt="foreignLanguages" />
                </a>
                <div className="categoryInfo">
                  <a className="categoryBotton" id="btnBook3">
                    <span>مهر و مــــــاه</span>
                  </a>
                </div>
              </div>
            </a>
          </div>
          <div id="mainSection" className="categoryContainer">
            <a
              target=""
              className="logoLink"
              id="Book4"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D9%85%D8%A8%D8%AA%DA%A9%D8%B1%D8%A7%D9%86-2"
            >
              <div className="categoryBox">
                <img
                  className="categoryImageBorderRadius"
                  alt="PublicBooks"
                  src={Book4}
                />
                <div className="categoryInfo">
                  <a className="categoryBotton2" id="btnBook4">
                    <span>مبتکران</span>
                  </a>
                </div>
              </div>
            </a>

            <a
              target=""
              className="logoLink"
              id="Book5"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D8%A7%D9%84%DA%AF%D9%88"
            >
              <div className="categoryBox">
                <a target="" className="logoLink">
                  <img
                    className="categoryImageBorderRadius"
                    src={Book5}
                    alt="ChildrenBooks"
                  />
                </a>
                <div className="categoryInfo">
                  <a className="categoryBotton" id="btnBook5">
                    <span>الــــــــــــگو</span>
                  </a>
                </div>
              </div>
            </a>
            <a
              target=""
              className="logoLink"
              id="Book6"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D9%86%D8%A7%D8%B1%D9%86%D8%AC%DB%8C"
            >
              <div className="categoryBox">
                <a target="" className="logoLink">
                  <img src={Book6} alt="foreignLanguages" />
                </a>
                <div className="categoryInfo">
                  <a className="categoryBotton2" id="btnBook6">
                    <span>نارنــــــجی</span>
                  </a>
                </div>
              </div>
            </a>
          </div>
          <div id="mainSection" className="categoryContainer">
            <a
              target=""
              className="logoLink"
              id="Book7"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D9%85%D8%B4%D8%A7%D9%88%D8%B1%D8%A7%D9%86-%D8%A2%D9%85%D9%88%D8%B2%D8%B4-2"
            >
              <div className="categoryBox">
                <a target="" className="logoLink">
                  <img src={Book7} alt="foreignLanguages" />
                </a>
                <div className="categoryInfo">
                  <a className="categoryBotton" id="btnBook7">
                    <span>مشاوران آموزش</span>
                  </a>
                </div>
              </div>
            </a>
            <a
              target=""
              className="logoLink"
              id="Book8"
              href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%DA%A9%D8%A7%D9%86%D9%88%D9%86-%D9%81%D8%B1%D9%87%D9%86%DA%AF%DB%8C-%D8%A2%D9%85%D9%88%D8%B2%D8%B4-%D9%82%D9%84%D9%85-%DA%86%DB%8C"
            >
              <div className="categoryBox">
                <a target="" className="logoLink">
                  <img src={Book8} alt="foreignLanguages" />
                </a>
                <div className="categoryInfo">
                  <a className="categoryBotton2" id="btnBook8">
                    <span>قلـــم چـــی</span>
                  </a>
                </div>
              </div>
            </a>
            <a
              target=""
              className="logoLink"
              id="morebook"
              href="https://www.gajmarket.com/634"
            >
              <div className="categoryBox">
                <div
                  style={{
                    height: "350px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <a target="" className="logoLink">
                    <img src={More} alt="foreignLanguages" />
                  </a>
                </div>
                <div className="categoryInfo">
                  <a className="categoryBotton" id="btnMore">
                    <span>سایر ناشران</span>
                  </a>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div className="footer">
          <a target="" className="logoLink" href="https://www.gajmarket.com/">
            <img src={LogoFooter} />
          </a>
          {/* <div className="social">
            <a
              target=""
              className="logoLink"
              href="https://www.gajmarket.com/"
            >
              <img src={telegram} />
            </a>
            <a
              target=""
              className="logoLink"
              href="https://www.gajmarket.com/"
            >
              <img src={Instagram} />
            </a>
          </div> */}
        </div>
      </div>

      <div className="mobile mobileContainer">
        <a href="#mainSectionMobile">
          <div className="mainImageContainer">
            <img className="main-img" src={BackgroundMobile} />
            <div class="centered">
              <img style={{ marginTop: "15px" }} src={GajmarketLogoMobile} />
              <div>
                <img
                  className="komak-darsi-img"
                  style={{ position: "relative", top: "20px" }}
                  src={HelpTextMobile}
                />
              </div>
              {/* <div
                class="flex-bc"
                style={{ position: "relative", top: "-20px" }}
              >
                <p className="info-text">
                  تا
                  <span style={{ margin: "0 5px" }}>۳۰</span>
                  درصد تخفیف
                </p>
                <p className="info-text-m">۱۵  تا ۳۰ مهر</p>
              </div> */}
              <div
                className="header"
                style={{ position: "relative", top: "20px" }}
              >
                <span>
                  <img
                    src={LogoTextMobile}
                    style={{ position: "relative", top: "2px" }}
                  />
                </span>
                <span className="header-text">
                  ؛ فروشگاه تخصصی کتاب و لوازم تحریر
                </span>
              </div>
              {/* <div
                className="time-left"
                style={{ position: "relative", top: "-35px" }}
              >
                <p className="time-text-title">زمان باقی مانده</p>
                <p className="time-text">
                  {leadingZero(days)} : {leadingZero(hours)} :
                  {leadingZero(minutes)} : {leadingZero(seconds)}
                </p>
              </div> */}
            </div>
          </div>
        </a>
        <div
          id="mainSectionMobile"
          style={{ position: "relative", top: "-50px" }}
          className="categoryContainer"
        >
          <a
            target=""
            className="logoLink"
            id="Book1"
            href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D8%A8%DB%8C%D9%86-%D8%A7%D9%84%D9%85%D9%84%D9%84%DB%8C-%DA%AF%D8%A7%D8%AC"
          >
            <div className="categoryBox">
              <img
                className="categoryImageBorderRadius"
                src={Bookm1}
                alt="PublicBooks"
              />
              <div className="categoryInfo">
                <a className="categoryBotton" id="btnBook1">
                  <span>انتشارات بین المللی گاج</span>
                </a>
              </div>
            </div>
          </a>
          <a
            target=""
            className="logoLink"
            id="Book2"
            href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D8%AE%DB%8C%D9%84%DB%8C-%D8%B3%D8%A8%D8%B2"
          >
            <div className="categoryBox">
              <img
                className="categoryImageBorderRadius"
                src={Bookm2}
                alt="PublicBooks"
              />
              <div className="categoryInfo">
                <a className="categoryBotton2" id="btnBook2">
                  <span>خیــلـــــی سبـــــز</span>
                </a>
              </div>
            </div>
          </a>
          <a
            target=""
            className="logoLink"
            id="Book3"
            href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D9%85%D9%87%D8%B1-%D9%88-%D9%85%D8%A7%D9%87"
          >
            <div className="categoryBox">
              <img
                className="categoryImageBorderRadius"
                src={Bookm3}
                alt="PublicBooks"
              />
              <div className="categoryInfo">
                <a className="categoryBotton2" id="btnBook3">
                  <span>مهر و مــــــاه</span>
                </a>
              </div>
            </div>
          </a>
          <a
            target=""
            className="logoLink"
            id="Book4"
            href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D9%85%D8%A8%D8%AA%DA%A9%D8%B1%D8%A7%D9%86-2"
          >
            <div className="categoryBox">
              <img
                className="categoryImageBorderRadius"
                src={Bookm4}
                alt="PublicBooks"
              />
              <div className="categoryInfo">
                <a className="categoryBotton" id="btnBook4">
                  <span>مبتکران</span>
                </a>
              </div>
            </div>
          </a>
          <a
            target=""
            className="logoLink"
            id="Book5"
            href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D8%A7%D9%84%DA%AF%D9%88"
          >
            <div className="categoryBox">
              <img
                className="categoryImageBorderRadius"
                src={Bookm5}
                alt="PublicBooks"
              />
              <div className="categoryInfo">
                <a className="categoryBotton" id="btnBook5">
                  <span>الــــــــــــگو</span>
                </a>
              </div>
            </div>
          </a>
          <a
            target=""
            className="logoLink"
            id="Book6"
            href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D9%86%D8%A7%D8%B1%D9%86%D8%AC%DB%8C"
          >
            <div className="categoryBox">
              <img
                className="categoryImageBorderRadius"
                src={Bookm6}
                alt="PublicBooks"
              />
              <div className="categoryInfo">
                <a className="categoryBotton2" id="btnBook6">
                  <span>نارنــــــجی</span>
                </a>
              </div>
            </div>
          </a>
          <a
            target=""
            className="logoLink"
            id="Book7"
            href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%D9%85%D8%B4%D8%A7%D9%88%D8%B1%D8%A7%D9%86-%D8%A2%D9%85%D9%88%D8%B2%D8%B4-2"
          >
            <div className="categoryBox">
              <img
                className="categoryImageBorderRadius"
                src={Bookm7}
                alt="PublicBooks"
              />
              <div className="categoryInfo">
                <a className="categoryBotton2" id="btnBook7">
                  <span>مشاوران آموزش</span>
                </a>
              </div>
            </div>
          </a>
          <a
            target=""
            className="logoLink"
            id="Book8"
            href="https://www.gajmarket.com/%D8%A7%D9%86%D8%AA%D8%B4%D8%A7%D8%B1%D8%A7%D8%AA-%DA%A9%D8%A7%D9%86%D9%88%D9%86-%D9%81%D8%B1%D9%87%D9%86%DA%AF%DB%8C-%D8%A2%D9%85%D9%88%D8%B2%D8%B4-%D9%82%D9%84%D9%85-%DA%86%DB%8C"
          >
            <div className="categoryBox">
              <img
                className="categoryImageBorderRadius"
                src={Bookm8}
                alt="PublicBooks"
              />
              <div className="categoryInfo">
                <a className="categoryBotton" id="btnBook8">
                  <span>قلـــم چـــی</span>
                </a>
              </div>
            </div>
          </a>
          <a
            className="another-publisher"
            href="https://www.gajmarket.com/634"
            target=""
            id="morebook"
            style={{ textDecoration: "none" }}
          >
            <span>سایر ناشران ...</span>
          </a>
        </div>
        <div className="footer">
          <a target="" className="logoLink" href="https://www.gajmarket.com/">
            <img src={LogoFooterMobile} />
          </a>
          {/* <div className="social">
            <a
              target=""
              className="logoLink"
              href="https://www.gajmarket.com/"
            >
              <img src={telegramM} />
            </a>
            <a
              target=""
              className="logoLink"
              href="https://www.gajmarket.com/"
            >
              <img src={InstagramM} />
            </a>
          </div> */}
        </div>
      </div>
    </>
  );
}

export default App;
